import { Container } from '@spark-web/container';
import { Hidden } from '@spark-web/hidden';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLink } from '@spark-web/text-link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PARTNER_BRIGHTE_DISCLAIMER } from '~/constants';
import { MarketplacePartner } from '~/types/marketplace';
import { getBrighteSitePartnerUrl } from '~/utils/formatter';

type DisclaimerProps = {
  partner?: MarketplacePartner;
  size?: 'large' | 'medium';
  theme?: 'light' | 'dark';
};

export const Disclaimer: FC<DisclaimerProps> = ({ partner, size = 'large', theme = 'light' }) => {
  const { t } = useTranslation();

  const linkTone = theme === 'light' ? 'info' : 'neutral';

  return (
    <Container size={size}>
      <Stack gap="xxlarge" paddingX="large" paddingY="xxlarge">
        {partner ? PARTNER_BRIGHTE_DISCLAIMER[partner] : null}
        <Inline gap="large">
          <Text size="xsmall">
            {t('© {{currentYear}} Brighte Capital Pty Limited (ABN 74 609 165 906)', {
              currentYear: new Date().getFullYear(),
            })}
          </Text>
          <Hidden below="tablet">
            <Text size="xsmall">—</Text>
          </Hidden>
          <Text size="xsmall">
            <TextLink tone={linkTone} target="_blank" href={`${getBrighteSitePartnerUrl(partner)}/privacy`}>
              Privacy policy
            </TextLink>
          </Text>
          <Text size="xsmall">—</Text>
          <Text size="xsmall">
            <TextLink tone={linkTone} target="_blank" href={`${getBrighteSitePartnerUrl(partner)}/website-terms`}>
              Website terms
            </TextLink>
          </Text>
        </Inline>
      </Stack>
    </Container>
  );
};
